import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { FlowSteps } from '../FlowSteps';
import { familiarProblems, type ProblemBlock } from '../../data/salesContent';
export function ProblemSection() {
  return <PageSection labelledBy="familiar-title" className="bg-carbon-900" data-id="element-139" data-mp="8izagh72unql">
      <SectionHeading id="familiar-title" title="¿Te suena familiar?" subtitle={<>
            <p data-id="element-141" data-mp="3voq8wu8qvsoe">Enseñás Construcciones...</p>
            <p data-id="element-142" data-mp="3vrvva1pzoggf">pero cada vez que tenés que preparar un nuevo tema volvés a enfrentarte al mismo problema:</p>
          </>} data-id="element-140" data-mp="dibxp31v1wtp" />
      <div className="mt-8 space-y-5" data-id="element-143" data-mp="3lrvb6dkapwb6">
        {familiarProblems.map(({
        icon: Icon,
        title,
        blocks
      }) => <article key={title} className="rounded-xl border border-carbon-800 bg-carbon-950 p-6 md:p-7" data-id="element-144" data-mp="3qrhrivvf7so7">
            <div className="flex items-start gap-3" data-id="element-145" data-mp="1k1a2n1jr1q6g">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500/10 text-accent-400" data-id="element-146" data-mp="1oytho3o9u6zg">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-147" data-mp="1nmt1au7ja9hs" />
              </span>
              <h3 className="pt-1 text-xl font-extrabold uppercase leading-tight text-white md:text-2xl" data-id="element-148" data-mp="1ip9qk4a1oeul">{title}</h3>
            </div>
            <div className="mt-5 space-y-5" data-id="element-149" data-mp="1wfmw5zzgrhgr">
              {blocks.map((block, i) => <ProblemBlockView key={i} block={block} data-id="element-150" data-mp="1seb1vh5na828" data-mpi={i} />)}
            </div>
          </article>)}
      </div>
    </PageSection>;
}
function ProblemBlockView({
  block
}: {
  block: ProblemBlock;
}) {
  switch (block.kind) {
    case 'chips':
      return <ul className="flex flex-wrap gap-2" data-id="element-151" data-mp="zrqf6u046k50">
          {block.items.map(t => <li key={t} className="rounded border border-carbon-700 bg-carbon-900 px-3 py-1 text-sm font-medium text-carbon-200" data-id="element-152" data-mp="1dqq3u1nmmz16">
              {t}
            </li>)}
        </ul>;
    case 'text':
      return <div className="space-y-1.5 text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-153" data-mp="2p3iq4wxnev9u">
          {block.items.map(par => <p key={par} data-id="element-154" data-mp="2k5h7gd44wxyw">{par}</p>)}
        </div>;
    case 'question':
      return <p className="font-display text-3xl font-extrabold uppercase leading-tight tracking-wide text-accent-400 md:text-4xl" data-id="element-155" data-mp="1hr9mwllhnw2q">{block.text}</p>;
    case 'flow':
      return <div data-id="element-156" data-mp="1qt93jcslcy55">
          {block.lead && <p className="text-base text-carbon-300 md:text-[17px]" data-id="element-157" data-mp="1qu2d0lixq1qz">{block.lead}</p>}
          <FlowSteps steps={block.items} align="start" className="mt-2" data-id="element-158" data-mp="1vslzqo5crhke" />
        </div>;
    case 'closing':
      return <div className="rounded-lg border-l-4 border-accent-500 bg-accent-500/10 px-5 py-4 font-display text-lg font-extrabold uppercase leading-snug tracking-wide md:text-xl" data-id="element-159" data-mp="z2uv3w3cke0v">
          <p className="text-white" data-id="element-160" data-mp="181zsgz36a1bg">{block.items[0]}</p>
          <p className="text-accent-400" data-id="element-161" data-mp="1816uonm6ym5g">{block.items[1]}</p>
        </div>;
  }
}